module.exports = __webpack_public_path__ + "img/accounting-setting.4233b29b.svg";